import Masonry from 'masonry-layout'
import ImagesLoaded from 'imagesloaded'
import jQueryBridget from 'jquery-bridget'


function initMasonry($, selector) {
    if ($(selector).hasClass('loaded'))
        return;
    $(selector).addClass('loading')
    setTimeout(() => {
        ImagesLoaded(document.querySelector(selector), function () {
            $(selector).removeClass('loading').addClass('loaded')
            $(selector).find('img').removeClass('inLoading', false)
            $(selector).masonry({
                itemSelector: '.grid-item',
                percentPosition: true,
                gutter: 10
            })
        })
    }, 200)
}

export default function ProjectDetail($) {
    jQueryBridget('masonry', Masonry, $)

    let currentSection = null
    let isInnerSection = false
    let hash = window.location.hash.substr(1)
    if (hash) {
        openSection(hash ? hash : 'section-main')
    }

    function openSection(sectionName) {
        currentSection = sectionName.replace('section-', '')
        if (currentSection.indexOf('-') !== -1) {
            isInnerSection = true
            currentSection = currentSection.substring(0, currentSection.indexOf('-'))
        } else {
            isInnerSection = false
        }
        window.scrollTo(0,0);
        $('#project-detail section').hide();
        $('#project-detail section#' + sectionName).fadeIn();
        $('#project-detail section#' + sectionName + ' span.postload').each(function () {
            $(this).replaceWith($("<img />", {class: 'inLoading', src: $(this).data('src')}));
        })
        let newurl = ("" + window.location).replace(/#[A-Za-z0-9_-]*$/, '') + "#" + sectionName
        window.history.replaceState("", "", newurl)
        if (['section-attachments', 'section-images', 'section-models', 'section-drawings'].indexOf(sectionName) != -1) {
            initMasonry($, '#' + currentSection + '-grid')
        } else {
            ImagesLoaded(document.querySelector('#' + sectionName), function () {
                $('#' + sectionName + ' img.inLoading').fadeIn().removeClass('inLoading')
                $('#' + sectionName + ' .loader').remove()
            })
        }
        $('#pd-sections a[data-section]').removeClass('active')
        $('#pd-sections a[data-section="' + currentSection + '"]').addClass('active')
    }

    $('#pd-sections a').click(function (e) {
        currentSection = $(this).data('section')
        //this for video links
        if (!currentSection)
            return;

        e.preventDefault()
        let prev = $('#pd-sections a.active').data('section')

        if (prev == currentSection) {
            currentSection = 'main'
        }
        openSection('section-' + currentSection)
    })

    $('a.section-link').click(function (e) {
        e.preventDefault()

        openSection($(this).attr('href').replace('#', ''))
    })

    $('#pd-close').click(function (e) {
        if (isInnerSection) {
            e.preventDefault()
            openSection('section-' + currentSection)
        }
    })
    $('#pd-bib a[data-tab]').click(function (e) {
        e.preventDefault()
        $('.bib-item').hide()
        $('#pd-bib-' + $(this).data('tab')).fadeIn()
        $('#pd-bib a[data-tab]').removeClass('active')
        $(this).addClass('active')
    })
}


// WEBPACK FOOTER //
// ./app/Resources/assets/js/front/projectdetail.jsx